// removed by extract-text-webpack-plugin
module.exports = {"order-status":"OrderStatus-module__order-status___2_WAt","header":"OrderStatus-module__header___3ou7s","icon":"OrderStatus-module__icon___K3RVY","mobile":"OrderStatus-module__mobile___3sikh"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/OrderStatus/OrderStatus.module.scss
// module id = 277
// module chunks = 0 1